import * as React from 'react';
import { Stack, Text } from 'office-ui-fabric-react';
import { NavLink } from 'react-router-dom';
import { HeaderSeparator } from '../HeaderSeparator';
import { Link } from '../Link';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderLink = _ref => {
  let {
    link,
    shouldRenderSeparator,
    isToExternalModule
  } = _ref;
  const headerLinkStyles = {
    root: {
      color: 'white',
      selectors: {
        '&:hover': {
          textDecoration: 'underline'
        }
      }
    }
  };
  const linkComponentStyles = {
    textDecoration: 'none'
  };
  const LinkComponent = props => isToExternalModule ? /*#__PURE__*/_jsx(Link, {
    href: link.Url,
    style: linkComponentStyles,
    children: props.children
  }) : /*#__PURE__*/_jsx(NavLink, {
    to: link.Url,
    style: linkComponentStyles,
    children: props.children
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Stack.Item, {
      align: "center",
      children: /*#__PURE__*/_jsx(LinkComponent, {
        children: /*#__PURE__*/_jsx(Text, {
          variant: "large",
          styles: headerLinkStyles,
          children: link.Name
        })
      })
    }), shouldRenderSeparator && /*#__PURE__*/_jsx(Stack.Item, {
      align: "center",
      children: /*#__PURE__*/_jsx(HeaderSeparator, {})
    })]
  });
};